import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserTabService {
  private readonly tabResetSource = new Subject<number>();
  tabReset$ = this.tabResetSource.asObservable();

  resetTab(index: number) {
    this.tabResetSource.next(index);
  }
}
